import React, {useState} from 'react'
import { Dialog, DialogTitle, TextField, DialogContent, DialogActions, Button } from '@mui/material'

function DialogLeyenda({
    leyenda,
    setLeyenda,
    openLeyendaModal,
    handleCloseLeyenda
}) {
    
    const [text, setText]=useState("");
    
    const handleGuardarLeyenda = () => {
        setLeyenda(text)
        handleCloseLeyenda();
    }

    return (
        <Dialog
            open={openLeyendaModal}
            onClose={handleCloseLeyenda}
            fullWidth
            maxWidth="sm"
        >
            <DialogTitle>Leyenda del Comprobante</DialogTitle>
            <DialogContent>
                <TextField
                    autoFocus
                    margin="dense"
                    label="Ingrese la leyenda u observación"
                    type="text"
                    fullWidth
                    multiline
                    rows={3}
                    variant="outlined"
                    value={text}
                    onChange={(e) => {
                        // console.log("holaa")
                        setText(e.target.value)
                    }}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCloseLeyenda} color="secondary">
                    Cancelar
                </Button>
                <Button onClick={handleGuardarLeyenda} color="primary" variant="contained">
                    Guardar
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default DialogLeyenda
